import Template from "./template";
import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../lib/itn-ui-kit/services/service-container";

export default class MCCRoute extends BaseRoute {
  @service("current-user-service") currentUserService;
  @service("repositories/actionable-items-repository") actionItemsRepository;

  element = (<Template />);

  async loader({ request, params }) {
    const defaultParams = {
      assigned_to_case: this.currentUserService?.user?.pk,
      action_type__in: "1,2,3,4",
      limit: 1000,
    };
    const url = new URL(request.url);
    let actionItems = [];
    const searchParams = Object.fromEntries(url.searchParams.entries());
    let newSearchParams = Object.assign(searchParams, defaultParams);
    try {
      if (this.currentUserService?.user?.pk) {
        actionItems = await this.actionItemsRepository.query(newSearchParams);
      }
    } catch (error) {
      console.log(error);
    }

    return {
      actionItems,
    };
  }
}
